module.exports = __webpack_public_path__ + "img/chevron-bar-left.452fbdcc.svg";